import { render } from "./ReferralPayers.vue?vue&type=template&id=082c061e&ts=true"
import script from "./ReferralPayers.vue?vue&type=script&lang=ts"
export * from "./ReferralPayers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__